'use client'
import { useEffect, useState } from 'react'

const useTailwindColor = () => {
  const [isClient, setIsClient] = useState(false)
  const getColor = (className: string) => {
    if (!isClient) return ''

    const tempElement = document.createElement('div')
    tempElement.className = className
    document.body.appendChild(tempElement)

    const color = getComputedStyle(tempElement).color

    document.body.removeChild(tempElement)

    return color
  }

  useEffect(() => {
    setIsClient(true)
  }, [])

  return {
    getColor,
  }
}

export default useTailwindColor
